var iconSizes = {
  sm: ['w-3', 'h-3'],
  md: ['w-4', 'h-4'],
  lg: ['w-6', 'h-6'],
  xl: ['w-8', 'h-8'],
  '2xl': ['w-12', 'h-12'],
  '3xl': ['w-16', 'h-16']
};

export { iconSizes };
//# sourceMappingURL=types.esm.js.map
